module.exports = __webpack_public_path__ + "img/denmark-eye-and-ear-diseases-male.38baa4ff.png";